<template>
	<div>
		<b-row>
			<b-col>
				<div class="card height">
					<p class="text-black text-center mx-3 my-2">Category</p>
				</div>
				<div class="card category">
					<div
						class="mt-3 mx-3"
						v-for="(category, index) in allCategories"
						:key="index"
					>
						<p
							v-b-toggle="`my-collapse-${index}`"
							class="category-list d-flex justify-content-between"
						>
							<router-link
								v-if="findCategory(category)"
								:to="routePath"
								>{{ category.catalogLabel.en }}</router-link
							>
							<span class="when-open">
								<b-icon-chevron-down></b-icon-chevron-down>
							</span>
							<span class="when-closed">
								<b-icon-chevron-right></b-icon-chevron-right>
							</span>
						</p>
						<b-collapse
							v-if="category.catalogLabel.en === 'Order Medicine?'"
							:id="`my-collapse-${index}`"
							visible
							appear
						>
							<div class="ml-4 sub-category-list">
								<router-link
									:to="{
										name: 'health-care',
										params: {
											market: marketList[6].name,
											marketid: marketList[6]._id,
											categoryid: category._id,
										},
									}"
									>Search specific item</router-link
								>
								<router-link
									:to="{
										name: 'order-prescription',
										params: {
											market: marketList[6].name,
											marketid: marketList[6]._id,
											categoryid: category._id,
										},
									}"
									exact
									>Order with prescription</router-link
								>
								<router-link
									:to="{
										name: 'pharmacy-Shop',
										params: {
											market: marketList[6].name,
											marketid: marketList[6]._id,
											categoryid: category._id,
										},
									}"
									exact
									>Go to Pharmacy Shop</router-link
								>
							</div>
						</b-collapse>
						<b-collapse
							v-if="category.catalogLabel.en === 'Book A Test?'"
							:id="`my-collapse-${index}`"
						>
							<div class="ml-4 sub-category-list">
								<router-link
									:to="{
										name: 'package-test',
										params: {
											market: marketList[6].name,
											marketid: marketList[6]._id,
										},
									}"
									>Package Tests</router-link
								>
								<router-link
									:to="{
										name: 'diagnostic-centers',
										params: {
											market: marketList[6].name,
											marketid: marketList[6]._id,
										},
									}"
									>Diagnostic Centers</router-link
								>
								<button>Looking For Specific Test</button>
							</div>
						</b-collapse>
					</div>
				</div>
			</b-col>
			<b-col cols="9"> </b-col>
		</b-row>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	data() {
		return {
			isCategory: false,
			routePath: {},
		};
	},
	computed: {
		...mapState({
			allCategories: (state) => state.healthCare.healthCareCategories,
			marketList: (state) => state["home"].marketList,
		}),
	},

	methods: {
		findCategory(category) {
			if (category.catalogLabel.en === "Order Medicine?") {
				this.routePath = {
					name: "health-care",
					params: {
						market: this.marketList[6].name,
						marketid: this.marketList[6]._id,
						categoryid: category._id,
					},
				};
				return true;
			} else if (category.catalogLabel.en === "Looking for Doctor?") {
				this.routePath = {
					name: "looking-for-doctor",
					params: {
						market: this.marketList[6].name,
						marketid: this.marketList[6]._id,
						categoryid: category._id,
					},
				};
				return true;
			} else if (category.catalogLabel.en === "Home Sample Collection?") {
				this.routePath = {
					name: "home-sample-collection",
					params: {
						market: this.marketList[6].name,
						marketid: this.marketList[6]._id,
						categoryid: category._id,
					},
				};
				return true;
			} else if (category.catalogLabel.en === "Health Advise") {
				this.routePath = {
					name: "",
					params: {},
				};
				return true;
			} else if (
				category.catalogLabel.en === "Looking for  Physiotherapist?"
			) {
				this.routePath = {
					name: "looking-for-physiotherapist",
					params: {
						market: this.marketList[6].name,
						marketid: this.marketList[6]._id,
						categoryid: category._id,
					},
				};
				return true;
			} else if (category.catalogLabel.en === "Book A Test?") {
				this.routePath = {
					name: "package-test",
					params: {
						market: this.marketList[6].name,
						marketid: this.marketList[6]._id,
						categoryid: category._id,
					},
				};
				return true;
			} else if (category.catalogLabel.en === "Hospitals & Nursing Home") {
				this.routePath = {
					name: "hospital-listing",
					params: {
						market: this.marketList[6].name,
						marketid: this.marketList[6]._id,
						categoryid: category._id,
					},
				};
				return true;
			}
		},
	},

	async mounted() {
		// await this.$store.dispatch(
		//   "healthCare/fetchSpecificItemsList",
		//   this.$route.params.marketid
		// );
		// await this.$store.dispatch("home/fetchMarketList");
	},
};
</script>

<style>
.height {
	height: 60px !important;
	background-color: #f9f9f9 !important;
	border-radius: 8px 8px 0px 0px;
	border-bottom: 0px;
	font-size: 16px;
	font-weight: 600;
	justify-content: center;
	align-items: start;
}

.category {
	width: 100%;
	border-radius: 0px 0px 8px 8px;
}

.router-link-exact-active {
	color: #fe7b08;
}
a {
	color: #000;
}
a:hover {
	color: #fe7b08;
	text-decoration: none;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
	display: none;
}
.category-list {
	font-size: 14px;
}
.sub-category-list {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	font-size: 12px;
}
</style>
